import FormattedMessage from 'I18n/components/FormattedMessage';
import { FileButton } from 'foundations-components/transitional/components/FileButton';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { useCallback, useState } from 'react';
import { getFilesAboveMaxSizeLimit, getFilesBelowMaxSizeLimit } from './utils';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { MAX_FILES_PER_PROPERTY } from './constants';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useHasNoUploadLimit } from '../v2/hooks/useHasNoUploadLimit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddFileButton = ({
  isEditDisabled,
  hasPropertyExtensionsMetadataError,
  onSelect,
  currentFilesCount
}) => {
  const [selectionExceedsMaxCount, setSelectionExceedsMaxCount] = useState(false);
  const hasNoUploadLimit = useHasNoUploadLimit();
  // As of March 2024, BE allows upto 2GB for portals with this scope.
  // CDP introduces a 50MB limit for these portals.

  const currentValueExceedsMaxCount = currentFilesCount >= MAX_FILES_PER_PROPERTY;
  const disableUpload = isEditDisabled || hasPropertyExtensionsMetadataError || currentValueExceedsMaxCount;
  const tooltip = currentValueExceedsMaxCount ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "customerDataProperties.PropertyInputFilesV2.addFileMaxCountReached",
    options: {
      maxFilePerProperty: MAX_FILES_PER_PROPERTY
    }
  }) : hasPropertyExtensionsMetadataError ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.PropertyInputFilesV2.addFileDisabledDueToMetadataError"
  }) : null;
  const remainingFilesCount = MAX_FILES_PER_PROPERTY - currentFilesCount;
  const handleChange = useCallback(e => {
    const {
      files: filesFromDisk
    } = e.target;
    if (!filesFromDisk) return;
    const files = Array.from(filesFromDisk);
    if (files.length > remainingFilesCount) {
      setSelectionExceedsMaxCount(true);
      return;
    }
    onSelect(getFilesBelowMaxSizeLimit(files, hasNoUploadLimit), getFilesAboveMaxSizeLimit(files, hasNoUploadLimit));
  }, [onSelect, remainingFilesCount, hasNoUploadLimit]);
  if (selectionExceedsMaxCount) {
    return /*#__PURE__*/_jsx(Alert, {
      use: "inline",
      type: "danger",
      closeable: true,
      onClose: () => setSelectionExceedsMaxCount(false),
      marginBlockStart: "100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataProperties.PropertyInputFilesV2.addFileMaxCountReachedOnSelection",
        options: {
          maxFilePerProperty: MAX_FILES_PER_PROPERTY
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltip,
    placement: "bottom",
    disabled: !disableUpload,
    children: /*#__PURE__*/_jsxs(FileButton, {
      use: "tertiary-light",
      size: "extra-small",
      onChange: handleChange,
      multiple: true,
      disabled: disableUpload,
      children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputFilesV2.addFile"
      })]
    })
  });
};
export default AddFileButton;